import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import IncorporadorasMeiliPage from '@/pages/incorporadoras/incorporadoras-meili-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

const incorporadorasSearchSchema = z.object({
  page: z.coerce.number().min(1).optional(),
})

// Rota index para /dashboard/$dashboardId/incorporadoras
// Listagem via MeiliSearch (InstantSearch)
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/incorporadoras/',
)({
  validateSearch: incorporadorasSearchSchema,
  component: function IncorporadorasIndexRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.INCORPORADORA} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <IncorporadorasMeiliPage dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
